module.exports = __webpack_public_path__ + "static/media/tofusaagpanner.66230e7d.jpg";